import { render, staticRenderFns } from "./AdmissionsIndex.vue?vue&type=template&id=d26614bc"
import script from "./AdmissionsIndex.vue?vue&type=script&lang=js"
export * from "./AdmissionsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d26614bc')) {
      api.createRecord('d26614bc', component.options)
    } else {
      api.reload('d26614bc', component.options)
    }
    module.hot.accept("./AdmissionsIndex.vue?vue&type=template&id=d26614bc", function () {
      api.rerender('d26614bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsIndex.vue"
export default component.exports